import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { UpdatePageHeader } from '../../Redux/Actions/PageHeaderAction';
import { IMAGE_UPLODER_HEADER } from '../../Constants/pageHeaders';
import { Col, Row, } from 'react-bootstrap';
import { ArrowUpCircleFill, Folder2Open } from 'react-bootstrap-icons';
import { ImageUploaderAction } from '../../Redux/Actions/ImageUploader';
import './style.css'
import Form from 'react-bootstrap/Form';


const ImageUploader = () => {
    const [image, setImage] = useState<any>({})
    const [isShowQR, setIsShowQR] = useState<any>(null)
    const [isLoading, setLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const dispatch = useDispatch()
    const uploaderState = useSelector((state: any) => state.ImageUploader)
    const ImageType = ['jpg', 'png', 'jpeg']

    useEffect(() => {
        dispatch(
            UpdatePageHeader({
                header: IMAGE_UPLODER_HEADER,
            })
        );
    }, [dispatch]);

    useEffect(() => {
        if (uploaderState?.imageData !== '') {
            setIsShowQR(dataURLtoFile(uploaderState?.imageData, 'qr_code.png'))
        }
    }, [uploaderState?.imageData]);

    function dataURLtoFile(dataurl: any, filename: any) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }

    useEffect(() => {
        setLoading(uploaderState?.loading)
    }, [uploaderState])

    const uploadImageHandler = () => {
        const formData = new FormData()
        formData.append('imageupload', image)
        dispatch(ImageUploaderAction(formData))
    }

    const onChangeFileHandler = (e: any) => {
        setIsShowQR(null)
        setShowError(false)
        setImage({})
        const file = e.target.files[0].name.split('.')
        const validateType = ImageType.find(
            (type: string) => type === file[file.length - 1]
        )

        if (validateType) setImage(e.target.files[0])
        else setShowError(true)
    }


    return (
        <div>
            <Row>
                <Col lg="6" md="8" className="mx-auto">
                    <h3 style={{ color: "#000", textAlign: 'center' }}>
                        Image Tester
                    </h3>
                    <div className="choose-wrap align-items-center" style={{ color: "black" }}>
                        <div className="choose-wrap-left">
                            <Form.Group controlId="formFile" className="choose-wrap-inner">
                                <Form.Label>Choose File </Form.Label>
                                <div className="icon-wrap">
                                    <Folder2Open />
                                </div>
                                <Form.Control type="file" onChange={onChangeFileHandler} />
                            </Form.Group>
                        </div>
                        <h5>{image?.name}</h5>
                        <div className="choose-wrap-right">
                            <Form.Group className="choose-wrap-inner">
                                <button onClick={uploadImageHandler}>{isLoading ? 'Loading...' : 'Upload Image'}</button>
                                <div className="icon-wrap">
                                    <ArrowUpCircleFill />
                                </div>
                            </Form.Group>
                        </div>
                    </div>
                    {showError &&
                        <div className='show-error'>
                            <p>File type should be .jpg, .png or .jpeg format</p>
                        </div>
                    }
                    {isShowQR && <div className="scan-wrap">
                        <h4 className="mb-4">Scan for preview</h4>
                        <div className="scaning-image" >
                            <img src={URL.createObjectURL(isShowQR)} alt='qrCode' />
                        </div>
                    </div>}
                </Col>
            </Row>

        </div>
    )
};

export default ImageUploader;

